import { createReducer, on } from "@ngrx/store";
import { Card, Contact, Customer, Funnel, LossReason, Pager, Product, Stage } from "lib-trend-core";
import { cloneDeep } from "lodash";
import * as CRMActions from "./actions";
import { CRMState } from "./app.state";

// initial global state
export const initialState: CRMState = {
  isLoading: false,
  company: undefined,
  user: undefined,
  funnel: undefined,
  funnels: new Array<Funnel>(),
  stages: new Array<Stage>(),
  stage: undefined,
  card: undefined,
  cards: new Pager<Card>(),
  products: new Array<Product>(),
  customers: new Array<Customer>(),
  lossReasons: new Array<LossReason>(),
  contacts: new Pager<Contact>(),
  queryParams: null,
  error: null,
}

//reducers
export const crmReducers = createReducer(
  initialState,
  on(CRMActions.clearFullState, (state) => ({ ...cloneDeep(initialState) })),

  on(CRMActions.getFunnels, (state, action) => ({ ...state, isLoading: true })),
  on(CRMActions.getFunnel, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getStages, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getStage, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getCards, (state, action) => ({ ...state, isLoading: true })),
  on(CRMActions.getCard, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getProducts, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getCustomers, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getLossReasons, (state) => ({ ...state, isLoading: true })),
  on(CRMActions.getContacts, (state) => ({ ...state, isLoading: true })),

  on(CRMActions.setFunnels, (state, action) => ({ ...state, isLoading: false, funnels: action.funnels })),
  on(CRMActions.setFunnel, (state, action) => ({ ...state, isLoading: false, funnel: action.funnel })),
  on(CRMActions.setStage, (state, action) => ({ ...state, isLoading: false, stage: action.stage })),
  on(CRMActions.setStages, (state, action) => ({ ...state, isLoading: false, stages: action.stages })),
  on(CRMActions.setCards, (state, action) => ({ ...state, isLoading: false, cards: action.cards })),
  on(CRMActions.setCard, (state, action) => ({ ...state, isLoading: false, card: action.card })),
  on(CRMActions.setProducts, (state, action) => ({ ...state, isLoading: false, products: action.products })),
  on(CRMActions.setCustomers, (state, action) => ({ ...state, isLoading: false, customers: action.customers })),
  on(CRMActions.setLossReasons, (state, action) => ({ ...state, isLoading: false, lossReasons: action.lossReasons })),
  on(CRMActions.setContacts, (state, action) => ({ ...state, isLoading: false, contacts: action.contacts })),


  on(CRMActions.setQueryParams, (state, action) => ({ ...state, queryParams: action.queryParams })),

  // init
  on(CRMActions.setLoadInit, (state, action) => ({ ...state, user: action.user, company: action.company })),

  // failure
  on(CRMActions.setFailure, (state, action) => ({ ...state, error: action.error })),
);
